__turbopack_context__.v({
  "descriptionField": "BHWH7a_descriptionField",
  "gantryFieldLabel": "BHWH7a_gantryFieldLabel",
  "impactBlock": "BHWH7a_impactBlock",
  "impactError": "BHWH7a_impactError",
  "impactLabel": "BHWH7a_impactLabel",
  "titleField": "BHWH7a_titleField",
  "titleFieldNeed": "BHWH7a_titleFieldNeed",
});
